export const enum UploadFieldEnum {
  LOGO = 'logo',
  CETIFICATE = 'certificate',
}
